import React from "react";
import { Field, Input, Select } from "@/components/erp/ui";
import { QrCode } from "lucide-react";

const REASONS = ["Stock Update", "Label Rusak", "Sample Uji"];

// Label QR di luar Purchasing Order (khusus Filament & Resin)
export const MovLabel = ({ form, setForm, unit }) => (
  <div className="rounded-xl border border-amber-200 bg-amber-50/60 p-3 space-y-3" data-testid="mov-label-box">
    <div className="text-xs font-semibold text-amber-800 flex items-center gap-1"><QrCode className="w-3.5 h-3.5" /> LABEL QR NON-PO</div>
    <div className="grid grid-cols-2 gap-3">
      <Field label="Kategori label">
        <Select data-testid="mov-label-reason" value={form.label_reason || ""} onChange={(e) => setForm({ ...form, label_reason: e.target.value, label_units: form.label_units || 1 })}>
          <option value="">Tidak cetak label</option>
          {REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
        </Select>
      </Field>
      {form.label_reason && <Field label="Jumlah unit (spool/botol)"><Input type="number" min={1} data-testid="mov-label-units" value={form.label_units || 1} onChange={(e) => setForm({ ...form, label_units: e.target.value })} /></Field>}
    </div>
    <p className="text-[11px] text-amber-700">Label ditandai "NON-PO · {form.label_reason || "kategori"}" supaya beda dari label PO. {form.label_reason === "Label Rusak" ? "Untuk ganti label rusak, Qty boleh 0 (stok tidak berubah)." : `Qty stok tetap dalam ${unit || "satuan"} item.`} Tiap unit dicetak 2 label.</p>
  </div>
);
